
import React from "react";
import { connect } from "react-redux";

import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser,
        project: store.project
    };
})
class Links extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            members:[],
            workstreams:[],
            openTag:false,
            selectedWorkstream:[],
            selectedMembers:[],
            subject:null

        }
        _.map(
            ["fetchWorkstreams"],
            fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }

    componentDidMount () {
        this.fetchWorkstreams();
    }

    fetchWorkstreams(options = null){
        const { loggedUser } = this.props;
        let fetchUrl = `/api/workstream`;
        const params={
            projectId: this.props.project.Selected.id,
            page:1,
            userId: loggedUser.data.id,
            userRole: loggedUser.data.userRole,
            workstreamStatus: 'Active',
            section: 'conversation',
            ...(options ? { workstream: options } : {})
        }

        Axios.get(fetchUrl, params).then(c => {
            if(c) {
                const workstreamOptions = _(c.data.result)
                    .map(e => {
                        return { value: e.id, label: e.workstream, color: e.color, workstream: e};
                    }).value();

                this.setState({ ...this.state, workstreams: workstreamOptions });
            }
        });
         
    }

    render() {
        const { dispatch, conversations } = this.props;

        const handleSelectworkstreams = (value)=>{
            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_ONLY", selected: {...conversations.selected, tagged_workstreams_notes: [...conversations.selected.tagged_workstreams_notes, {...value, fromOption: true}] } });
        }
        
        const handleRenderOptionWorkstream = value =>{
            return (
                <div class="taggedWorkstreamDetails">
                     <div class="workstreamStatusIndicator" style={{background: `${value.color}`}}></div>
                    <div class="taggedWorkstreamContent">
                        <p>{value.label}</p>
                    </div>
                </div>
            );
        }
        
        return (
            <div class="workstreamListInput">
                <h4>Workstreams</h4>
                <Select 
                    isSearchable={true}
                    classes={{options: `recipientOptions workstreamConvoOptions`}}
                    options={this.state.workstreams}
                    placeholder="Add/Search Workstreams"
                    onChange={handleSelectworkstreams}
                    renderOption={handleRenderOptionWorkstream}
                    searchIcon={<i class="material-icons">search</i>}
                    selected={ conversations.fields.workstreams }
                    isClose={ conversations.actionType === "formSubmit" }
                    showSelectedInInput={ false }
                    exclude={ conversations.selected.tagged_workstreams_notes.map( u => u.workstream.id )}
                />
            </div>
        );
    }
}

export default Links;